<agpr-dialog-container
    [id]="'mentionImportConfirmation'"
    [contentPadding]="false"
    (close)="closeDialog()"
    heading="Monitoring.mentionImporter.confirmation.heading"
>
    <div class="agpr-mentionImportConfirmation">
        <agpr-scroll-panel>
            <div class="agpr-mentionImportConfirmation-header">
                <span class="agpr-mentionImportConfirmation-headerIcon agpr-i-line-import-mentions" aria-hidden="true"></span>
                <div class="agpr-mentionImportConfirmation-headerText">
                    <p class="agpr-mentionImportConfirmation-headerMainText">{{ 'Monitoring.mentionImporter.confirmation.headerMainText' | localize }}</p>
                    <p class="agpr-mentionImportConfirmation-headerSubText">{{ 'Monitoring.mentionImporter.confirmation.headerSubText' | localize }}</p>
                </div>
            </div>
            <p class="agpr-mentionImportConfirmation-instructionLine">{{ 'Monitoring.mentionImporter.confirmation.instructionLine' | localize }}</p>
            <agpr-panel
                *ngIf="files.length > 0"
                header="Monitoring.mentionImporter.confirmation.sourceFileNames"
                class="agpr-mentionImportConfirmation-fileNames"
                [toggleable]="false"
            >
                <span
                    *ngFor="let file of files"
                    class="agpr-mentionImporter-sidebar-uploadedFile"
                >
                    {{ file.name }}
                </span>
            </agpr-panel>
            <agpr-panel
                *ngIf="fileParameters.folders.length > 0 || fileParameters.tags.length > 0 || parameters.importToSystemCollection"
                header="Monitoring.mentionImporter.confirmation.importSummary"
                [toggleable]="false"
                class="agpr-mentionImportConfirmation-importSummary"
                [ngClass]="{ 'agpr-mentionImportConfirmation-importSummary--last' : !parameters.importToSystemCollection }"
            >
                <label *ngIf="fileParameters.folders.length > 0">{{ 'Monitoring.mentionImporter.confirmation.addedToFolders' | localize }}</label>
                <ul *ngIf="fileParameters.folders.length > 0">
                    <li
                        *ngFor="let folder of fileParameters.folders"
                        class="agpr-mentionImportConfirmation-importSummary-collectionLabel"
                    >
                        {{ folder.name }}
                    </li>
                </ul>
                <label *ngIf="fileParameters.tags.length > 0">{{ 'Monitoring.mentionImporter.confirmation.addedToTags' | localize }}</label>
                <ul *ngIf="fileParameters.tags.length > 0">
                    <li
                        *ngFor="let tag of fileParameters.tags"
                        class="agpr-mentionImportConfirmation-importSummary-collectionLabel"
                    >
                        {{ tag.name }}
                    </li>
                </ul>
            </agpr-panel>
            <p
                *ngIf="parameters.importToSystemCollection"
                class="agpr-mentionImportConfirmation-importSummary-systemCollection"
            >
                {{ 'Monitoring.mentionImporter.importOptions.importToSystemCollection' | localize }}
            </p>
            <div class="agpr-mentionImportConfirmation-disclaimer">
                <agpr-checkbox
                    id="mentionImportConfirmation_checkbox"
                    [binary]="true"
                    [(ngModel)]="termsAccepted"
                >
                    {{ 'Monitoring.mentionImporter.confirmation.disclaimer' | localize }}<a class="agpr-mentionImportConfirmation-disclaimer-link" href="https://www.agilitypr.com/agility/terms-of-use/" target="_blank">{{ 'Monitoring.mentionImporter.confirmation.terms' | localize }}</a>
                </agpr-checkbox>
            </div>
        </agpr-scroll-panel>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            id="cancelButton"
            label="Core.button.cancel"
            (click)="closeDialog()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            id="confirmationButton"
            label="Monitoring.mentionImporter.importCsvButton"
            [disabled]="!termsAccepted || isBusy"
            [style]="buttonTypes.primary"
            (click)="importCsv()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>